import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { ChevronDown } from 'lucide-vue-next';
    import { SelectIcon, SelectTrigger, type SelectTriggerProps, useForwardProps } from 'reka-ui';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectTrigger',
  props: {
    disabled: { type: Boolean },
    reference: {},
    asChild: { type: Boolean },
    as: {},
    class: {},
    size: { default: 'default' }
  },
  setup(__props: any) {

    const props = __props;

    const delegatedProps = reactiveOmit(props, 'class', 'size');
    const forwardedProps = useForwardProps(delegatedProps);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SelectTrigger), _mergeProps({
    "data-slot": "select-trigger",
    "data-size": _ctx.size
  }, _unref(forwardedProps), {
    class: 
            _unref(cn)(
                `border-input data-[placeholder]:text-faded-foreground [&_svg:not([class*='text-'])]:text-foreground aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive disabled:bg-faded flex w-fit cursor-pointer items-center justify-between gap-2 rounded-md border bg-transparent px-2.5 py-2 text-xs whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none disabled:cursor-not-allowed data-[size=default]:h-7.5 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
                props.class,
            )
        
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_unref(SelectIcon), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ChevronDown), { class: "size-4 opacity-50" })
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 16, ["data-size", "class"]))
}
}

})